module.exports = __webpack_public_path__ + "img/Lokal-Lab.822b53d6.png";